/* eslint-disable max-statements */
import React, { useState, useEffect } from "react";
import BookingOtp from "../../shared/booking-otp-v2/component";
import Button from "../../shared/button";
import PropTypes from "prop-types";
import InputMobile from "../../shared/input-mobile";
import CloseButton from "../../shared/icon-cross";
import styles from "./styles.css";
import Modal from "../../shared/modal";
import { mobileNumberValidator } from "../../../utils/validators/mobile-number-validator";
import BulletLoader from "../../shared/bullet-loader";
import { NUMBER } from "../../../constants/app-constants";
import { sendCustomGaEvents } from "../../../tracking";

const withOtpDesktop = (Component) => (useAuth) => {
    const OtpComponent = (props) => {

        const {
            close,
            isLoggedIn = false,
            mobile,
            isEditable = true,
            showInModal = true,
            skipMobile = false,
            pageType = ""
        } = props || {};

        const [isLoginRequired, setIsLoginRequired] = useState(!isLoggedIn);
        const [phoneNumber, setPhoneNumber] = useState(mobile);
        const [showOtpField, setShowOtpField] = useState(skipMobile);
        const [errorMessage, setErrorMessage] = useState("");
        const [isLoading, setIsLoading] = useState(null);

        const { getOtpHandler, onResendClick, onOtpVerify, details = {}, checkIfLoginRequired, leadDetails = {}, isPhoneChanged } = useAuth(props);
        const { maskedPhone = "" } = details || {};

        useEffect(() => {
            if (phoneNumber !== "" && phoneNumber !== null) {
                checkIfLoginRequired({isLoggedIn, mobileNumber: phoneNumber}).then(() => {
                    setIsLoginRequired(false);
                }).catch(() => {
                    setIsLoginRequired(true);
                });
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        const onClose = () => {
            close();
        };

        const resetErrorMessage = () => {
            setErrorMessage("");
        };

        const onOtpChange = (number) => {
            if (number && number.length === NUMBER.ONE) resetErrorMessage();
        };

        const onChangeHandler = (e) => {
            const {target: {value}} = e;
            setPhoneNumber(value);
        };

        const otpHandler = () => {
            setIsLoading(true);
            getOtpHandler(phoneNumber).then(() => {
                setIsLoading(false);
                setShowOtpField(true);
            }).catch(() => {
                setIsLoading(false);
            });
        };

        const errorCallbackHandler = (error) => {
            setErrorMessage(error);
            setIsLoading(false);
        };

        const getBtnDisabledState = () => {
            if (!isEditable) return !maskedPhone.length;
            return !(mobileNumberValidator(phoneNumber));
        };

        const onOtpVerifyHandler = (inputOtp) => {
            setIsLoading(true);
            resetErrorMessage();
            onOtpVerify(inputOtp, phoneNumber, errorCallbackHandler).then(() => {
                setIsLoading(false);
                setIsLoginRequired(false);
                if (pageType) {
                    sendCustomGaEvents({
                        event: "login_done",
                        eventAction: "login_done",
                        eventLabel: pageType
                    });
                }
            }).catch((errorCode) => {
                setIsLoading(false);
                setErrorMessage(errorCode);
            });
        };

        const resendOtpHandler = () => {
            onResendClick(phoneNumber);
        };

        const renderScreen = () => {
            return (
                <React.Fragment>
                    {!showOtpField ?
                        <div styleName={`styles.wrapper ${showInModal ? "styles.modalWrapper" : ""}`}>
                            <div styleName="styles.wrapperText">
                                {showInModal && <CloseButton type="grey" onClick={onClose} styleName={"styles.close"} />}
                                <h3>Login to continue</h3>
                                <InputMobile
                                    isPrefixAsFixed={true}
                                    value={maskedPhone || phoneNumber}
                                    onChange={onChangeHandler}
                                    isLabelShift={false}
                                    rightImg={mobileNumberValidator(phoneNumber)}
                                    disabled={!isEditable}
                                />
                                {
                                    errorMessage &&
                                <small styleName={"styles.invalid"}>
                                    {errorMessage}
                                </small>
                                }
                                <Button
                                    isLoading={isLoading}
                                    text="Proceed"
                                    onClick={otpHandler}
                                    disabled={getBtnDisabledState()}
                                />
                            </div>
                        </div>
                        : <React.Fragment>
                            <BookingOtp
                                isRevamped={true}
                                isMissCallEnabled={false}
                                close={close}
                                onOtpChange={onOtpChange}
                                onChangeComplete={onOtpVerifyHandler}
                                resendOTP={resendOtpHandler}
                                isError={!!errorMessage}
                                errorMessage={errorMessage || errorMessage}
                                showSpinner={isLoading}
                                displayType="desktop"
                                mobileNumber={maskedPhone || phoneNumber}
                                showClose={showInModal}
                            />
                            { isLoading && <div styleName={"styles.buttetLoader"}>
                                <BulletLoader />
                            </div>
                            }
                        </React.Fragment>
                    }
                </React.Fragment>
            );
        };

        if (!isLoginRequired) {
            return (
                <Component
                    details={details}
                    showInModal={showInModal}
                    isPhoneChanged={isPhoneChanged}
                    leadDetails={leadDetails}
                    {...props} />
            );
        }

        return (
            <React.Fragment>
                {showInModal ?
                    <Modal isOpen={isLoginRequired}>{renderScreen()} </Modal>
                    : <React.Fragment> {renderScreen()}</React.Fragment>}
            </React.Fragment>
        );
    };

    OtpComponent.propTypes = {
        close: PropTypes.func,
        mobile: PropTypes.string,
        isLoggedIn: PropTypes.bool,
        isEditable: PropTypes.bool,
        skipMobile: PropTypes.bool
    };

    return OtpComponent;

};
export default withOtpDesktop;
